module.exports = __webpack_public_path__ + "static/media/bfile-vacant-land.c65ce3cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-vacant-land.svg
// module id = 169
// module chunks = 0